(() => {
  const root = document.querySelector("[data-zc-header-banner]");
  if (!root) return;

  const header = root.closest(".header") || document.querySelector(".header");

  const headerIsSolid = () => {
    if (!header) return true;
    if (!header.hasAttribute("transparent")) return true;
    return header.getAttribute("data-sticky-state") === "active";
  };

  let tapeBuilder = null;

  const syncBannerHeight = () => {
    if (!header) return;
    const visible = getComputedStyle(root).display !== "none";
    header.style.setProperty("--zc-banner-h", visible ? `${root.offsetHeight}px` : "0px");
  };

  const syncVisibility = () => {
    root.classList.toggle("is-solid", headerIsSolid());
    syncBannerHeight();
    if (tapeBuilder) tapeBuilder();
  };

  syncVisibility();

  if (header) {
    const observer = new MutationObserver(syncVisibility);
    observer.observe(header, { attributes: true, attributeFilter: ["transparent", "data-sticky-state"] });
  }

  window.addEventListener("scroll", syncVisibility, { passive: true });

  const tapeStyle = root.dataset.style;
  if (tapeStyle === "tape" || tapeStyle === "tape_emoji") {
    const marquee = root.querySelector("[data-zc-banner-marquee]");
    const seed = marquee?.querySelector("[data-zc-banner-loop]");
    if (!marquee || !seed || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let lastWidth = 0;

    const buildLoop = () => {
      if (root.offsetWidth === 0) return;
      if (root.offsetWidth === lastWidth && marquee.classList.contains("is-ready")) return;
      lastWidth = root.offsetWidth;

      marquee.querySelectorAll("[data-zc-banner-loop]").forEach((el, i) => {
        if (i > 0) el.remove();
      });

      const minWidth = root.offsetWidth * 2 + Math.max(seed.offsetWidth, 1);
      let guard = 0;
      while (marquee.scrollWidth < minWidth && guard < 16) {
        const clone = seed.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        marquee.appendChild(clone);
        guard += 1;
      }

      const loopPx = seed.offsetWidth;
      if (loopPx < 8) return;

      marquee.style.setProperty("--zc-banner-loop", `${loopPx}px`);
      marquee.style.setProperty("--zc-banner-tape-s", `${Math.max(10, loopPx / 70)}s`);
      marquee.classList.add("is-ready");
      marquee.style.animation = "none";
      void marquee.offsetWidth;
      marquee.style.animation = "";
    };

    tapeBuilder = buildLoop;
    const ro = new ResizeObserver(buildLoop);
    ro.observe(root);
    buildLoop();
    return;
  }

  const slides = [...root.querySelectorAll("[data-zc-banner-slide]")];
  if (slides.length < 2) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const speed = Math.max(2, Number(root.dataset.speed) || 5) * 1000;
  let index = 0;
  let timer = 0;

  const show = (next) => {
    slides[index].classList.remove("is-active");
    slides[index].hidden = true;
    index = next;
    slides[index].hidden = false;
    slides[index].classList.add("is-active");
  };

  const tick = () => show((index + 1) % slides.length);

  const start = () => {
    stop();
    timer = window.setInterval(tick, speed);
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
    timer = 0;
  };

  root.addEventListener("mouseenter", stop);
  root.addEventListener("mouseleave", start);
  root.addEventListener("focusin", stop);
  root.addEventListener("focusout", start);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stop();
    else start();
  });

  start();
})();
